import { $$, on } from './core/dom.js';

/** "Fold alle ud / sammen" over en liste af <details> (bruges på Vedtægter) */
export function initAccordionTools() {
  $$('[data-accordion]').forEach(btn =>
    on(btn, 'click', () => {
      const open = btn.dataset.accordion === 'open';
      $$('.statutes details').forEach(d => { d.open = open; });
    })
  );
}
